import { createContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import RouteConstants from "../../../constants/routeConstants.json";
import {
  dealerDetailsApi,
  dealerStatusChangeApi,
  deleteDealerApi,
} from "../../../api/Api";
import { useCookies } from "react-cookie";
import { handleApiError } from "../../../constants/Constants";
export const DealerDetailsContext = createContext({});

export const DealerDetailsContextProvider = ({ children }) => {
  const navigate = useNavigate();
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState("");
  const [buttonText, setButtonText] = useState("");
  const [dealerDetails, setDealerDetails] = useState([]);
  const [statusValue, setStatusValue] = useState(0);
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const [successPopup, setSuccessPopup] = useState(false);
  const [successPopupMessage, setSuccessPopupMessage] = useState("");
  const [deletePopup, setDeletePopup] = useState(false);
  const [statusPopup, setStatusPopup] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [statusChange, setStatusChange] = useState(false);
  const location = useLocation();
  const dealerId = location.state.id;
  const currentPage = location?.state?.page;
  const permissionAccess = JSON.parse(
    localStorage.getItem("permissions")
  )?.filter((item) => {
    return item.feature === "67b416502efc50c984271c7c";
  })[0];

  const statuses = [
    { _id: "A", name: "Active" },
    { _id: "I", name: "Inactive" },
  ];

  useEffect(() => {
    getDealerDetails(dealerId);
  }, [dealerId]);
  const editProduct = () => {
    navigate(RouteConstants.EDIT_DEALER, {
      state: { dealerData: dealerDetails, page: currentPage },
    });
  };
  const dealerToLogin = () => {
    navigate(RouteConstants.LOGIN);
    removeCookie("x-access-token");
  };
  // API dealer  delete
  const deleteDealer = async (id) => {
    try {
      setSpinnerStatus(true);
      const response = await deleteDealerApi(id);
      if (response.data.statusCode === 200) {
        setDeleteAlert(false);
        setSuccessPopup(true);
        setDeletePopup(false);
        setSpinnerStatus(false);
        setStatusPopup(false);
        setErrorPopup(false);
        setSuccessPopupMessage(response.data.message);
      }
    } catch (error) {
      handleApiError(
        error,
        setStatusValue,
        setErrorPopupMessage,
        setErrorPopup,
        setButtonText
      );
    }
    setSpinnerStatus(false);
  };
  const handleStatusChange = async (e) => {
    const newStatusId = e.target.value;
    setSpinnerStatus(true);

    try {
      const status = { status: newStatusId };
      const response = await dealerStatusChangeApi(status, dealerId);

      if (response.data.statusCode === 200) {
        setSelectedStatus(newStatusId);
        setDeleteAlert(false);
        setSuccessPopup(true);
        setDeletePopup(false);
        setSpinnerStatus(false);
        setStatusPopup(false);
        setErrorPopup(false);
        setSuccessPopupMessage(response.data.message);
        setStatusChange(true);
      }
    } catch (error) {
      setDeletePopup(false);
      handleApiError(
        error,
        setStatusValue,
        setErrorPopupMessage,
        setErrorPopup,
        setButtonText
      );
      setSpinnerStatus(false);
    }
  };
  const goToDealerList = () => {
    navigate(RouteConstants.LIST_DEALER, { state: { page: currentPage } });
  };

  // api for get dealers list
  const getDealerDetails = async (id) => {
    try {
      setSpinnerStatus(true);
      const response = await dealerDetailsApi(id);
      if (response?.status === 200) {
        setSpinnerStatus(false);
        setDealerDetails(response?.data?.data?.dealer);
        setSelectedStatus(response?.data?.data?.dealer?.status);
      }
    } catch (error) {
      if (error?.status === 404) {
        setErrorPopupMessage("");
        setErrorPopup(false);
        goToDealerList();
      } else {
        handleApiError(
          error,
          setStatusValue,
          setErrorPopupMessage,
          setErrorPopup,
          setButtonText
        );
      }
    }
    setSpinnerStatus(false);
  };

  const dealerTableList = () => {
    if (!statusChange) {
      navigate(RouteConstants.LIST_DEALER);
    }
  };

  const providerValue = {
    goToDealerList,
    permissionAccess,
    spinnerStatus,
    statuses,
    handleStatusChange,
    editProduct,
    deleteDealer,
    deleteAlert,
    setDeleteAlert,
    dealerDetails,
    errorPopup,
    errorPopupMessage,
    setErrorPopup,
    dealerToLogin,
    buttonText,
    dealerDetailsApi,
    statusValue,
    dealerTableList,
    successPopup,
    setSuccessPopup,
    successPopupMessage,
    dealerTableList,
    selectedStatus,
  };
  return (
    <DealerDetailsContext.Provider value={providerValue}>
      {children}
    </DealerDetailsContext.Provider>
  );
};
